import React, { ReactNode, useEffect } from 'react';
import { useAnalytics } from 'src/components/AnalyticsProvider/AnalyticsProvider';
import { useGetQueryParams } from 'src/utilities/useGetQueryParams';
import { useInitializeDatadogRum } from 'src/common/telemetry/DataDog/useInitializeDatadogRum';
import { useInitializeTealium } from 'src/common/telemetry/Tealium/useInitializeTealium';

interface IOnAppInitProps {
  children: ReactNode;
}

export function OnAppInit({ children }: IOnAppInitProps): JSX.Element {
  const { sendTealiumEvent } = useAnalytics();
  const gaLabel = useGetQueryParams('ga_label');

  useEffect(() => {
    if (gaLabel) {
      sendTealiumEvent({
        eventcategory: 'self-service sign up_get started',
        eventaction: 'standard account setup_get started_cta',
        eventlabel: `${gaLabel}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gaLabel]);

  useInitializeDatadogRum();
  useInitializeTealium();

  return <>{children}</>;
}
